// extracted by mini-css-extract-plugin
module.exports = {"name":"speakerCard-module--name--2v4X0","event":"speakerCard-module--event--2y1EJ"};